import React from 'react'
import { useStaticQuery } from 'gatsby';
import Avatar from '../Avatar';
import getThemeColor from "../../utils/getThemeColor";

import * as S from './styled';

const Profile = () => {
    const {
        site: {
            siteMetadata: {
                title,
                position,
                description
            }
        }
    } = useStaticQuery(graphql`
        query MySiteMetadata {
            site {
                siteMetadata {
                    title
                    position
                    description
                }
            }
        }
    `);

    return (
        <S.ProfileWrapper>
            <S.ProfileLink 
                cover
                direction="left"
                bg={getThemeColor()}
                duration={0.6}
                to="/"
            >
                <Avatar />
                <S.ProfileAuthor>
                    {title}
                    <S.ProfilePosition>{position}</S.ProfilePosition>
                </S.ProfileAuthor>
            </S.ProfileLink>
             <S.ProfileDescription>{description}</S.ProfileDescription>
    </S.ProfileWrapper>
    )

}

export default Profile;